import { DEFAULT_EXCEL_HEADER } from "./constants";

export async function downloadRdvBulkTemplate(defaultWorkplace = "") {
  const workplace = String(defaultWorkplace ?? "").trim();
  const ExcelJS = (await import("exceljs")).default;
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("지원인력");
  ws.addRow(DEFAULT_EXCEL_HEADER);
  ws.addRow([
    1,
    workplace,
    "비소방",
    "춘천시 자원봉사단",
    "1팀",
    "팀원",
    "홍길동",
    "010-1234-5678",
    "급식지원",
  ]);
  ws.columns.forEach((col) => {
    col.width = 16;
  });
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "rdv_support_template.xlsx";
  a.click();
  URL.revokeObjectURL(url);
}
